import { render, staticRenderFns } from "./xgIndex.vue?vue&type=template&id=454e8021&scoped=true&"
import script from "./xgIndex.vue?vue&type=script&lang=js&"
export * from "./xgIndex.vue?vue&type=script&lang=js&"
import style0 from "./xgIndex.vue?vue&type=style&index=0&id=454e8021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e8021",
  null
  
)

export default component.exports